<form
  class="contract d-flex direction-column align-center"
  [formGroup]="contractForm"
  [ngClass]="{ 'expand-body': bodyExpanded }"
>
  <div class="contract-header header d-flex align-center justify-space-between">
    <span> {{ contract.Number + " (v. "+ contract.Version +")" }} </span>

    <span class="header-text header-stage flex-1">
      {{ contract.StageName }}
    </span>

    <span class="body-info-data flex-1">
      {{ contract.Amount | currency : "BRL" || "-" }}
    </span>

    <span class="header-text flex-1">
      {{ (contract.FinancialInstitution | titlecase) || "-" }}
    </span>

    <span class="header-text flex-2">
      {{ (contract?.Client | titlecase) ?? "-" }}
    </span>

    <div class="d-flex align-center justify-flex-end flex-1">
      <span class="header-text header-status">
        {{ formatStatusText(contract.ContractStatus) | titlecase }}
      </span>

      <button
        class="d-flex align-center justify-center header-expand btn-icon"
        (click)="bodyExpanded = !bodyExpanded"
      >
        <app-svg-icon
          class="header-expand-svg"
          src="assets/icons/arrow-icon.svg"
          alt="expand"
          width="8px"
          color="arrowGray"
        ></app-svg-icon>
      </button>
    </div>
  </div>

  <div
    [ngClass]="{ 'expand-divider': bodyExpanded }"
    class="divider d-flex justify-start"
  ></div>

  <div
    class="contract-body body d-flex justify-space-between justify-center align-center"
  >
    <div class="body-info d-flex basis-92 row-gap-16 column-gap-16">
      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Banco:</span>
        <span class="body-info-data">{{
          contract.FinancialInstitution | titlecase
        }}</span>
      </div>

      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Status Contrato:</span>
        <span class="body-info-data">{{
          formatStatusText(contract.Status) | titlecase
        }}</span>
      </div>

      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Dt.Produção:</span>
        <span class="body-info-data">
          {{ contract.ContractDate | date : "dd/MM/yyyy" }}
        </span>
      </div>

      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Valor:</span>
        <span class="body-info-data">{{
          (contract.Amount | currency : "BRL") ?? "-"
        }}</span>
      </div>

      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Canal</span>
        <span class="body-info-data">{{ contract.Chanel }}</span>
      </div>

      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Consulta:</span>
        <span class="body-info-data">{{ contract.QueryNumber }}</span>
      </div>

      <div class="body-info group d-flex direction-column row-gap-4">
        <span class="body-info-label">Tipo:</span>
        <span class="body-info-data">{{ contract?.ContractType ?? "-" }}</span>
      </div>
    </div>
  </div>
</form>
